import { memo } from "react";

import { IconButton, Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

import styles from "../SearchBar.module.scss";
import { useSearchBar } from "../context";

import { SearchBarIcon } from "./SearchBar.Misc";
import SearchBarResults from "./SearchBarResults/SearchBarResults";

const SearchBarExpanded = () => {
  const { l10n } = useLocalization();
  const { setClosed, searchTerm, setSearchTerm, paneRef } = useSearchBar();

  return (
    <div ref={paneRef} className={styles["search-pane"]}>
      <Row className={styles["search-pane-bar"]} alignItems="center">
        <SearchBarIcon />
        <Row.Item>
          <input
            autoFocus
            type="search"
            className={styles["search-input"]}
            aria-label={l10n.getString("search-bar-collapsed-placeholder")}
            value={searchTerm}
            onChange={(x) => setSearchTerm(x.target.value)}
          />
        </Row.Item>
        <IconButton name="x" textSize="l" onClick={setClosed} />
      </Row>
      <SearchBarResults />
    </div>
  );
};

export default memo(SearchBarExpanded);
